import React, { useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Unit } from '../../../helpers/unit';
import { unsubscribeMapEgKPI, getMapEGKPI, removeMapEGKPIBox } from '../../../actions/map';
import { BalerKPI, NonTruckKPI, SensorBox, TruckKPI } from './KPIBox';
import { fetchSensorData } from '../../../actions/analyze';
import { dateToUTC } from '../../../helpers/moment-ex';

const EGKPIBox = props => {
    const unit = Unit.getInstance();
    const { egInfo, settings, search: { range, rangeId } } = props;
    let { kpiData } = props;

    const isRequestingTravelKpi = useSelector(state => state.analyze.travelKpi.isRequesting);
    const travelKpi = useSelector(state => state.analyze.travelKpi.data);
    const timezone = useSelector(state => state.farm.currentFarm.timezone_identifier);
    const egReportIssue = useSelector(state => state.equipmentGroup.EGReportIssue.list);
    const egIssue = egReportIssue && egInfo && egInfo.egId ? egReportIssue[egInfo.egId] : null;
    const dispatch = useDispatch();

    const startDate = dateToUTC(props.search.custom.from, timezone).format();
    const endDate = dateToUTC(props.search.custom.to, timezone).format();

    const closeBox = () => {
        props.actions.unsubscribeMapEgKPI(props.egInfo.egId);
        props.actions.removeMapEGKPIBox(props.egInfo.egId);
        props.onClose(props.egInfo.egId);
    };

    useEffect(() => () => closeBox(), []);

    useEffect(() => {
        props.actions.getMapEGKPI({
            ...props.egInfo,
            range: props.search.range,
            fromDate: props.search.custom.from,
            toDate: props.search.custom.to,
            planTypeId: props.selectedPlanType
        });
    }, [rangeId]);

    useEffect(() => {
        let reqParams;
        if (range === "planned" || range === "todate") {
            reqParams = {
                equipment_group_uuid: egInfo.egId,
                sensor: "cgps0",
                range_type: range,
                farm_uuid: egInfo.farmId
            }
        }
        else {
            reqParams = {
                equipment_group_uuid: egInfo.egId,
                sensor: "cgps0",
                range_type: range,
                from_date: startDate,
                to_date: endDate,
                farm_uuid: egInfo.farmId
            }
        }
        dispatch(fetchSensorData(reqParams));
    }, [egInfo.egId, props.search.custom, range]);

    const distanceTravelled = travelKpi && travelKpi[egInfo.egId] ? unit.toRoundOfDistance(travelKpi[egInfo.egId]) : 0;

    kpiData = { ...kpiData, distanceTravelled, isRequestingTravelKpi };

    return <>
        <div className={`d-flex justify-content-between box-${egInfo.isTruck ? 'truck' : 'nontruck'}`}>
            <div className="w-100"><h6 className="word-wrap my-1"><span>{egInfo.name}</span> <span>
                {egIssue && !egIssue.is_resolve && <i className="fa fa-exclamation-triangle ml-1" style={{ color: "red" }} title={egIssue.issue}></i>}
            </span>
                {egInfo.operatorName && <div style={{ fontSize: "small" }} className='text-muted'>{egInfo.operatorName}</div>}
            </h6></div>
            <div className="flex-shrink-2 cls-bx hand-symbol" title="close" onClick={closeBox}>
                <i className="fa fa-times"></i>
            </div>
        </div>
        <div className="d-flex box-content">
            <div className="flex-shrink-1">
                <img alt="" className="control-box-img" src={egInfo.smallImgUrl} />
            </div>
            <div className="w-100 col-info">
                {kpiData && egInfo.kpiType === "truck" &&
                    <TruckKPI
                        kpiData={kpiData}
                        unit={unit}
                        settings={settings}
                    />}
                {kpiData && egInfo.kpiType === "nontruck" &&
                    <NonTruckKPI
                        kpiData={kpiData}
                        unit={unit}
                        settings={settings}
                    />}
                {kpiData && egInfo.kpiType === "baler" &&
                    <BalerKPI
                        kpiData={kpiData}
                        unit={unit}
                        settings={settings}
                    />}
            </div>
        </div>
        {kpiData && <SensorBox egInfo={egInfo} kpiData={kpiData} />}
    </>;
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        getMapEGKPI, removeMapEGKPIBox,
        unsubscribeMapEgKPI, fetchSensorData
    }, dispatch)
});

const mapStateToProps = (state, ownProps) => ({
    kpiData: state.map.egKPIBoxList[ownProps.egInfo.egId] ?
        state.map.egKPIBoxList[ownProps.egInfo.egId] : null,
    search: {
        range: state.analyze.searchParams.range,
        rangeId: state.analyze.searchParams.rangeId,
        custom: state.analyze.searchParams.custom
    },
    settings: state.user.settings,
    selectedPlanType: state.plan.selectedPlanType
});

export default connect(mapStateToProps, mapDispatchToProps)(EGKPIBox);